import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ViewSDKClient } from 'src/app/core/services/viewSDKClient.service';

@Component({
  selector: 'app-example',
  templateUrl: './example.component.html',
  styleUrls: ['./example.component.scss']
})
export class ExampleComponent implements OnInit {
  path:string = ''
  constructor(
    private route:ActivatedRoute,
    private viewSDKClient: ViewSDKClient 
  ) {
    this.route.params.subscribe((params: any) => {
      this.path = params.path;
    })
   }

  ngOnInit(): void {
    // this.renderPDf()
  }

  renderPDf() {
    this.viewSDKClient.ready().then(() => {
      /* Invoke file preview */
      const canvas: any = document.querySelector('#pdf-div');
      canvas.style.display = "block";
      canvas.style.height = "100vh";
      let defConfg = {
        showAnnotationTools: false, 
        showPageControls: true, 
        showDownloadPDF: true, 
        showPrintPDF: true
        // defaultViewMode: "FIT_WIDTH"
      }
      //this.viewSDKClient.previewFile('pdf-div', defConfg, this.fileUrl.url,'');
      this.viewSDKClient.previewFile('pdf-div', defConfg,'assets/doc/example/'+this.path+'.pdf','');
      //this.viewSDKClient.previewFile('pdf-div', defConfg,'assets/doc/example/plaint001.pdf','');
    });
  }

}
